import { gql } from "@apollo/client";

export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization($data: UpdateOrganizationInputData!, $orgId: String!) {
    updateOrganization(data: $data, orgId: $orgId) {
      id
      name
    }
  }
`;
